import { industries } from "../actions/types"

const defaultIndustriesData = {
	data: [],
	redirectUrl: null,
	isLoading: true,
	hasError: false,
	error: null,
	isShowing: false,
	isLoadingActions: false,
	isSavingPermissions: false,
	isRedirecting: false,
	isExporting: false,
	isDeleting: false,
	isRestoring:false,
	isValidating:false,
	filters: [],
	meta: {
		pagination: {
			total: 0,
			count: 0,
			per_page: 15,
			current_page: 1,
			total_pages: 1,
		}
	}
}

const industriesReducer = (state = defaultIndustriesData, action = []) => {
	switch (action.type) {

		case industries.GET_INDUSTRIES_STARTED:
			return { ...state, isLoading: true }

		case industries.GET_INDUSTRIES_SUCCESS:
			if (action.payload)
				return { ...state, ...action.payload, isLoading: false }
			return state

		case industries.GET_INDUSTRIES_ERROR:
			return { ...state, isLoading: false, hasError: true }

		case industries.SHOW_INDUSTRIES_STARTED:
			return { ...state, isShowing: true }

		case industries.SHOW_INDUSTRIES_SUCCESS:
			if (!action.payload.id)
				return state
			if (state.data.find(item => (item.id === action.payload.id)))
				return { ...state, isShowing: false, data: state.data.map(item => (item.id === action.payload.id ? action.payload : item)) }
			return { ...state, data: [...state.data, action.payload], isShowing: false }

		case industries.SHOW_INDUSTRIES_ERROR:
			return { ...state, isShowing: false, hasError: true }

		case industries.CREATE_INDUSTRIES_STARTED:
			return { ...state, isSaving: true }

		case industries.CREATE_INDUSTRIES_SUCCESS:
			if (action.payload)
				return {
					...state,
					data: [...state.data, { ...action.payload.data }],
					isSaving: false
				}
			return state

		case industries.CREATE_INDUSTRIES_ERROR:
			return { ...state, isSaving: false, hasError: true }

		case industries.DELETE_INDUSTRIES_STARTED:
			return {...state, isDeleting:true}

		case industries.DELETE_INDUSTRIES_SUCCESS:
			if (action.payload)
				return {...state, data: state.data.filter(item => (item.id !== action.payload.id)), isDeleting: false}
			return state

		case industries.DELETE_INDUSTRIES_ERROR:
			return { ...state, isDeleting:false, hasError:true }
		default:
			return state
	}
}


export default industriesReducer
